const result = {
  ordered1: {
    type: 'ordered',
    format: [
      { type: 'decimal', suffix: '.' },
      { type: 'lower-alpha', suffix: '.' },
      { type: 'lower-roman', suffix: '.' },
    ],
    googleDocsId: 'NUMBERED_DECIMAL_ALPHA_ROMAN',
  },
  ordered2: {
    type: 'ordered',
    format: [
      { type: 'decimal', suffix: ')' },
      { type: 'lower-alpha', suffix: ')' },
      { type: 'lower-roman', suffix: ')' },
      { type: 'decimal', prefix: '(', suffix: ')' },
      { type: 'lower-alpha', prefix: '(', suffix: ')' },
      { type: 'lower-roman', prefix: '(', suffix: ')' },
      { type: 'decimal', suffix: '.' },
      { type: 'lower-alpha', suffix: '.' },
      { type: 'lower-roman', suffix: '.' },
    ],
    googleDocsId: 'NUMBERED_DECIMAL_ALPHA_ROMAN_PARENS',
  },
  ordered3: {
    type: 'ordered',
    format: [{ type: 'decimal-multilevel', suffix: '.' }],
    googleDocsId: 'NUMBERED_DECIMAL_NESTED',
  },
  ordered4: {
    type: 'ordered',
    format: [
      { type: 'upper-alpha', suffix: '.' },
      { type: 'lower-alpha', suffix: '.' },
      { type: 'lower-roman', suffix: '.' },
      { type: 'decimal', suffix: '.' },
      { type: 'lower-alpha', suffix: '.' },
      { type: 'lower-roman', suffix: '.' },
      { type: 'decimal', suffix: '.' },
      { type: 'lower-alpha', suffix: '.' },
      { type: 'lower-roman', suffix: '.' },
    ],
    googleDocsId: 'NUMBERED_UPPERALPHA_ALPHA_ROMAN',
  },
  ordered5: {
    type: 'ordered',
    format: [
      { type: 'upper-roman', suffix: '.' },
      { type: 'upper-alpha', suffix: '.' },
      { type: 'decimal', suffix: '.' },
      { type: 'lower-alpha', suffix: ')' },
      { type: 'decimal', prefix: '(', suffix: ')' },
      { type: 'lower-alpha', prefix: '(', suffix: ')' },
      { type: 'lower-roman', prefix: '(', suffix: ')' },
      { type: 'lower-alpha', prefix: '(', suffix: ')' },
      { type: 'lower-roman', prefix: '(', suffix: ')' },
    ],
    googleDocsId: 'NUMBERED_UPPERROMAN_UPPERALPHA_DECIMAL',
  },
  ordered6: {
    type: 'ordered',
    format: [
      { type: 'decimal-leading-zero', suffix: '.' },
      { type: 'lower-alpha', suffix: '.' },
      { type: 'lower-roman', suffix: '.' },
      { type: 'decimal', suffix: '.' },
      { type: 'lower-alpha', suffix: '.' },
      { type: 'lower-roman', suffix: '.' },
      { type: 'decimal', suffix: '.' },
      { type: 'lower-alpha', suffix: '.' },
      { type: 'lower-roman', suffix: '.' },
    ],
    googleDocsId: 'NUMBERED_ZERODECIMAL_ALPHA_ROMAN',
  },
  unordered1: {
    type: 'unordered',
    format: [
      { type: 'bullet', text: '●' },
      { type: 'bullet', text: '○' },
      { type: 'bullet', text: '■' },
    ],
    googleDocsId: 'BULLET_DISC_CIRCLE_SQUARE',
  },
  unordered2: {
    type: 'unordered',
    format: [
      { type: 'bullet', text: '❖' },
      { type: 'bullet', text: '➢' },
      { type: 'bullet', text: '■' },
      { type: 'bullet', text: '●' },
      { type: 'bullet', text: '◆' },
      { type: 'bullet', text: '➢' },
      { type: 'bullet', text: '■' },
      { type: 'bullet', text: '●' },
      { type: 'bullet', text: '◆' },
    ],
    googleDocsId: 'BULLET_DIAMONDX_ARROW3D_SQUARE',
  },
  unordered3: {
    type: 'unordered',
    format: [{ type: 'checkbox', unchecked: '☐', checked: '☑' }],
    googleDocsId: 'BULLET_CHECKBOX',
  },
  unordered4: {
    type: 'unordered',
    format: [
      { type: 'bullet', text: '➔' },
      { type: 'bullet', text: '◆' },
      { type: 'bullet', text: '●' },
      { type: 'bullet', text: '○' },
      { type: 'bullet', text: '◆' },
      { type: 'bullet', text: '●' },
      { type: 'bullet', text: '○' },
      { type: 'bullet', text: '◆' },
      { type: 'bullet', text: '●' },
    ],
    googleDocsId: 'BULLET_ARROW_DIAMOND_DISC',
  },
  unordered5: {
    type: 'unordered',
    format: [
      { type: 'bullet', text: '★' },
      { type: 'bullet', text: '○' },
      { type: 'bullet', text: '■' },
      { type: 'bullet', text: '●' },
      { type: 'bullet', text: '○' },
      { type: 'bullet', text: '■' },
      { type: 'bullet', text: '●' },
      { type: 'bullet', text: '○' },
      { type: 'bullet', text: '■' },
    ],
    googleDocsId: 'BULLET_STAR_CIRCLE_SQUARE',
  },
  unordered6: {
    type: 'unordered',
    format: [
      { type: 'bullet', text: '➢' },
      { type: 'bullet', text: '○' },
      { type: 'bullet', text: '■' },
      { type: 'bullet', text: '●' },
      { type: 'bullet', text: '○' },
      { type: 'bullet', text: '■' },
      { type: 'bullet', text: '●' },
      { type: 'bullet', text: '○' },
      { type: 'bullet', text: '■' },
    ],
    googleDocsId: 'BULLET_ARROW3D_CIRCLE_SQUARE',
  },
}
result['ordered-standard'] = result.ordered5
result['unordered-standard'] = result.unordered1

export const listItemConfigurations = result
